<template>
  <div id="repayAccount">
    <div class="container">
      <headNav>
        <div slot="headNavText">Trung tâm thanh toán</div>
      </headNav>
      <div class="banksBox">
        <h4>{{$t('message.repay_hklx')}}</h4>

        <div class="item">
          <div :class="active2==index?'active':''" @click="change('hklx',index,item)"
               v-for="(item,index) in getDataTypes" :key="index">{{item.name}}
          </div>
        </div>
        <div style="margin-top: 10px" v-if="showXNK">
          <h4>{{$t('message.repay_style')}}</h4>

          <div class="item">
            <div :class="active1==index?'active':''" @click="change('sty',index,item)"
                 v-for="(item,index) in repayLXList" :key="index">{{item}}
            </div>
          </div>
          <van-field v-model="halfAmount" type="number" :label="$t('message.repay_money')" placeholder="Nhập số tiền"
                     v-if="iptAmount" style="margin-bottom: 15px;border-radius: 5px"/>
          <div style="color: red;font-size: 12px">
            <!--            <p>仅支持系统上展示的还款方式，任何人告知的其他还款方式皆为虚假信息。</p>-->
            <!--            <p>请务必正确填写系统显示的备注信息，否则系统将无法自动入账。</p>-->
            <!--            <p>请务必不要保存还款信息，同一张卡仅限还款一次。</p>-->
            <p style="font-weight: 600">Chỉ thanh toán theo số tài khoản hiện trên hệ thống. Bất cứ số tài khoản nào khác đều là lừa đảo!</p>
            <p>Vui lòng thanh toán và ghi nội dung đúng như thông tin trên hệ thống, nếu không sẽ không thể tự động xoá nợ.</p>
            <p>Vui lòng không lưu thông tin thanh toán trước đó, mỗi link và stk thanh toán chỉ dùng được 1 lần.</p>
          </div>
        </div>

        <div class="hkzh" v-if="hkzh">
          <div class="items">
            <div>
              <p>{{$t('message.repay_skdw')}}</p>
            </div>
            <div>
              <p>{{hubank}}</p>
            </div>
          </div>
          <div class="items">
            <div>
              <p>{{$t('message.repay_bank_news')}}</p>
            </div>
            <div>
              <p>{{bankName}}</p>
            </div>
          </div>
          <div class="items">
            <div>
              <p>{{$t('message.repay_zh')}}</p>
            </div>
            <div>
              <p>{{bankcard}}</p>
            </div>
          </div>
          <!--          <div class="items" v-if="repayStyNum==1">-->
          <!--            <div >-->
          <!--              <p>{{$t('message.repay_next_date')}}</p>-->
          <!--            </div>-->
          <!--            <div >-->
          <!--              <p>{{nextPayTime}}</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="items">
            <div>
              <p>{{$t('message.repay_money')}}</p>
            </div>
            <div>
              <p>{{add_comma_toThousands(repayMen)}}{{coin}}</p>
            </div>
          </div>
          <div class="items">
            <div>
              <p>{{$t('message.repay_server_money')}}</p>
            </div>
            <div>
              <p>{{serviceFee}}</p>
            </div>
          </div>
          <div class="items" v-if="repayStyValue==1">
            <div>
              <p>{{$t('message.loan_dq')}}</p>
            </div>
            <div>
              <p>{{dqsj}}</p>
            </div>
          </div>
          <!--        复制卡号-->
        </div>
        <div style="color: red;font-size: 12px;margin: 14px 7px 0;" v-if="hkzh">
          <!--          系统为了资金安全，升级还款方式A，并在近期将取消还款方式B，建议优先使用还款方式A-->
          <!--          请务必不要保存还款信息。-->
          <p>Để tăng sự an toàn cho khách hàng, hệ thống nâng cấp phương thức thanh toán A và sẽ hủy bỏ phương thức thanh toán B trong thời gian tới. Đề nghị ưu tiên sử dụng phương thức A</p>
          <p>Vui lòng vào app lấy lại thông tin cho mỗi lần thanh toán chuyển khoản</p>
        </div>
        <van-button type="primary" block style="margin-top: 35px" @click="copy(bankcard)" class="btns" v-if="hkzh">Sao chép số tài khoản</van-button>
      </div>
      <div style="width: 90%;font-size: 12px;margin: 20px auto 0" v-if="hkbtn">
        <van-button type="primary" block style="margin-top: 15px" @click="repay()" class="btns">{{$t('message.com_repay')}}</van-button>
        <!--        如果不能跳转到还款地址，请点击下面的<复制还款链接>按钮，在新页面粘贴并打开还款地址，进行还款操作。-->
        <div v-if="hasGetLink" style="margin-top: 0.3rem">Nếu không thấy hiện ra link thanh toán, vui lòng chọn "Sao chép link thanh toán" ở phía dưới. Dán link vào trình duyệt, tìm kiếm và tiến hành thanh toán.</div>
        <van-button type="info" block style="margin-top: 15px" @click="copy(repayLink)" class="btns" v-if="hasGetLink">Sao chép link thanh toán</van-button>
      </div>
    </div>

  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {
    getBanksNews,
    sassSearchBanksList,
    deBankCard,
    postRenInfo,
    delBank,
    sassRepaySty,
    sassGFaccount, sassRepayMoney, isXuQi
  } from '../../../ports/port'

  export default {
    name: "addBanks",
    data() {
      return {
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        banksArr: [],//银行卡列表
        active1: 0,
        active2: 0,
        repaySty: [],
        getDataTypes: [],
        orderId: '',
        showXNK: false,
        hubank: '',
        bankName: '',
        bankcard: '',
        repayMen: '',
        serviceFee: '',
        coin: this.$coin,
        halfAmount: '',
        hkzh: false,
        iptAmount: false,
        hkbtn: false,
        repayStyNum: 0,
        repayLXList: [this.$t('message.quank'), 'Thanh toán 1 phần', this.$t('message.xuq')],//Thanh toán 1 phần  =>部分还款
        hasGetLink:false,
        repayLink:'',
        repayStyValue:0,
        dqsj:''
      }
    },
    components: {
      headNav
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.orderId = this.$route.query.orderid;
      this.repaySty = this.$route.query.repaySty;
      if(this.repaySty==0){
        this.repayStyValue=2;
      }else{
        this.repayStyValue=1;
      }

      this.$store.commit('edit', true);//关闭全局的loading
      sassRepaySty({orderid: this.orderId, new: 1})
        .then(res => {
          this.$store.commit('edit', false);//关闭全局的loading
          this.getDataTypes = res.data.data;
          // res.data.data.map((el, index) => {
          //   this.repaySty.push(el.name);
          // });
          //虚拟卡
          if (res.data.data[0].type == 2) {
            this.showXNK = false;
            this.repayStyAjax(this.repayStyValue, 1);
            this.hkzh = true;
          } else {
            this.showXNK = true;
            this.hkbtn = true;
          }
          // this.repayFS =res.data.data[0].name;
          // this.repayStyNum=0;
          // this.showTips = res.data.data[0].type;
          // this.showTitle = res.data.data[0].name;
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
      // 判断是否可以续期还是全款
      isXuQi({orderid: this.orderId})
        .then(res => {
          if (res.data.code != 200) {
            this.repayLXList.pop();
          }
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
    },
    methods: {
      // 复制到剪切板
      copy(text) {
        let textareaEl = document.createElement('textarea');
        // 防止手机上弹出软键盘
        textareaEl.setAttribute('readonly', 'readonly');
        textareaEl.value = text;
        document.body.appendChild(textareaEl);
        textareaEl.select();
        let res = document.execCommand('copy');
        document.body.removeChild(textareaEl);
        this.$toast({message: 'Sao chép thành công', type: 'success', icon: 'success'});
        return res;
      },

      change(t, index, d) {
        if (t == 'sty') {
          this.active1 = index;
          if(index==1){//部分还款
            this.iptAmount=true;
            this.repayStyNum=1;
          }else if(index==0){//全款
            this.iptAmount=false;
            this.repayStyNum=0;
          }else{//续期
            this.iptAmount=false;
            this.repayStyNum=1;
          }
        } else {
          this.active2 = index;
          if (d.type != 2) {
            this.showXNK = true;
            this.hkzh = false;
            this.hkbtn = true;
          } else if (d.type == 2) {
            this.showXNK = false;
            this.hkzh = true;
            this.repayStyAjax(2, 1);
            this.hkbtn = false;
          }
        }
      },
      repayStyAjax(t, ret) { //t=>全款续期  repay_type=》1:虚拟卡    2=》还款链接
        let data = {userid: this.tk.userid, orderid: this.orderId, type: t, repay_type: ret};
        sassRepayMoney(data)
          .then(res => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (res.data.code == 200) {
              if (res.data.data.length != 0) {
                if (res.data.data && res.data.data.type == 2) {
                  this.showLink = true;
                  this.link = res.data.data.repay_url;
                } else {
                  // 以下是虚拟卡
                  this.showInfo = true;
                  this.hubank = res.data.data.accountName;
                  this.bankName = res.data.data.bankName;
                  this.bankbranch = res.data.data.branchBankName;
                  this.bankcard = res.data.data.accountNo;
                  this.banklink = res.data.data.bankLink;
                  this.serviceFee = res.data.data.serviceFee;
                  this.repayMen = res.data.data.money;
                  this.dqsj = res.data.data.reback_date;
                }
              }
            } else {
              this.$notify({type: 'danger', message: res.data.msg});
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      repay() {
        if (this.repayFS != "" && this.repayLX != "") {
          this.$store.commit('edit', true);//关闭全局的loading
          if (this.repayStyNum == 0) {//全款
            if (this.showTips == 1) {//官方账户还款
              sassGFaccount({orderid: this.orderId})
                .then(res => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (res.data.code == 200) {
                    let dataStr = JSON.stringify(res.data.data);
                    this.$router.push({path: '/schedule/repay/repayAccount', query: {'data': dataStr}})
                  } else {
                    this.$notify({type: 'danger', message: res.data.msg});
                  }
                })
                .catch(err => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (err.toString().indexOf('timeout') != -1) {
                    this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                  }
                })
            } else {//银行，商店还款
              let data;
              if (this.iptAmount) {
                data = {userid: this.tk.userid, orderid: this.orderId, type: 0, money: this.halfAmount, repay_type: 2};
                if (this.halfAmount - 0 < 100000 || this.halfAmount - 0 > 50000000) {
                  this.$toast({message: 'Ít nhất 100.000,Không vượt quá 50.000.000', type: 'danger', icon: 'fail'});
                  this.$store.commit('edit', false);//关闭全局的loading
                  return false
                }
              } else {
                data = {userid: this.tk.userid, orderid: this.orderId, type: 0, repay_type: 2};
              }
              // let tempwindow = window.open('_blank');
              sassRepayMoney(data)
                .then(res => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (res.data.code == 200) {
                    // tempwindow.location = res.data.data.repay_url;
                    this.$router.push({path:'/repayView',query:{url: res.data.data.repay_url}});
                    this.repayLink = res.data.data.repay_url;
                    this.hasGetLink = true;
                  } else {
                    this.$notify({type: 'danger', message: res.data.msg});
                  }
                })
                .catch(err => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (err.toString().indexOf('timeout') != -1) {
                    this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                  }
                })
            }
            // } else if (this.repayStyNum == 1) {//续期
          } else {//续期 或者部分还款
            if (this.showTips == 1) {//官方账户还款
              sassGFaccount({orderid: this.orderId})
                .then(res => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (res.data.code == 200) {
                    // this.showInfo = true;
                    // this.showLoading = false;
                    // this.bankAccountName = res.data.data.name;
                    // this.bankAccountNumber = res.data.data.card_number;
                    // this.bankAccount = res.data.data.bank_type;
                    // this.beizhu = res.data.data.mark;
                    let dataStr = JSON.stringify(res.data.data);
                    this.$router.push({path: '/schedule/repay/repayAccount', query: {'data': dataStr}})
                  } else {
                    this.$notify({type: 'danger', message: res.data.msg});
                  }
                })
                .catch(err => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (err.toString().indexOf('timeout') != -1) {
                    this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                  }
                })
            } else {
              let data;
              if (this.iptAmount) {
                data = {userid: this.tk.userid, orderid: this.orderId, type: 1, money: this.halfAmount, repay_type: 2};
                if (this.halfAmount - 0 < 100000 || this.halfAmount - 0 > 50000000) {
                  this.$toast({message: 'Ít nhất 100.000,Không vượt quá 50.000.000', type: 'danger', icon: 'fail'});
                  this.$store.commit('edit', false);//关闭全局的loading
                  return false
                }
              } else {
                data = {userid: this.tk.userid, orderid: this.orderId, type: 1, repay_type: 2};
              }
              // let tempwindow = window.open('_blank');
              sassRepayMoney(data)
                .then(res => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (res.data.code == 200) {
                    // tempwindow.location = res.data.data.repay_url;
                    this.$router.push({path:'/repayView',query:{url: res.data.data.repay_url}});
                    this.repayLink = res.data.data.repay_url;
                    this.hasGetLink = true;
                  } else {
                    this.$notify({type: 'danger', message: res.data.msg});
                  }
                })
                .catch(err => {
                  this.$store.commit('edit', false);//关闭全局的loading
                  if (err.toString().indexOf('timeout') != -1) {
                    this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
                  }
                })
            }
          }
        } else {
          this.$notify({type: 'danger', message: this.$t('message.jcNEWS')});
        }
      },
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
    }
  }
</script>

<style scoped lang="scss">
  #repayAccount {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .container {
      background: #F5F5F5;
      padding: 0 0 1px;
      /*min-height: 77vh;*/
      flex: 1;

      .title {
        text-align: center;
        background: white;
        font-size: 16px;
        padding: 10px 0;
        border-bottom: 1px solid #F2F4FB;
        position: relative;

        i {
          position: absolute;
          left: 20px;
          font-size: 20px;
        }
      }

      .banksBox {
        padding: 55px 15px 0;

        .accounts {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          padding: 0.3rem;
          border-radius: 8px;
          box-sizing: border-box;
          box-shadow: 0rem 0rem 0rem 0rem rgba(200, 200, 200, 0.49);
          margin-bottom: 15px;

          > :nth-child(1) {
            width: 35%;
            margin-right: 10px;

            img {
              width: 100%;
            }
          }

          > :nth-child(2) {
            width: 65%;
          }
        }
      }

      #add_bank_btn {
        @include defaultBtn;
        background-color: #fff !important;
        color: #242424;
        border: 1px solid #dad8d8;
        box-shadow: 0rem 0rem 0rem 0rem rgba(145, 145, 145, 0.4);
        border-radius: 8px !important;
      }
    }

    /deep/ .van-dialog__content {
      text-align: center;
    }
  }

  .item {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    div {
      background: #fff;
      border-radius: 5px;
      padding: 12px 10px;
      /*margin-right: 15px;*/
      /*margin-bottom: 15px;*/
      box-sizing: border-box;
      border: 1px solid #fff;
      position: relative;
      box-shadow: 3px 3px 10px #ebe9e9;
      text-align: center;
      width: 45%;
      margin: 0 7px 15px;

      i {
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 22px;
      }
    }

    .active {
      border: 1px solid $color;
      color: $color;
    }
  }

  .btns {
    @include defaultBtn
  }

  .hkzh {
    background: #fff;
    border-radius: 5px;
    padding: 15px;
    box-shadow: 3px 3px 10px #ebe9e9;
    margin: 0 7px;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.44rem 0;
      font-size: 14px;
      border-bottom: 1px solid #E9E9E9;

      div {
        color: gray;
      }

      > div:nth-child(1) {
        color: #8E97A6;
      }
    }

    .items {
      display: flex;
      padding: 0 6px;

      > div {
        flex: 1;
      }

      :nth-child(2) {
        text-align: right;
      }
    }
  }

  /deep/ .van-field__label {
    width: 8.2em !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/repay/repayCenter.vue